export default __webpack_public_path__ + "static/Clarendon_Hotel_1-7f008e1dc1546c50678fd0bb0807d564.jpg";